import type { SegmentRule, SegmentVocabularyField } from '../lib';
import { ContactChannel, ConsentStatus } from '../lib';

/** A blank rule for a freshly chosen field — the operator its spec lists first, and no value yet. */
export function blankRule(spec: SegmentVocabularyField): SegmentRule {
  const rule: SegmentRule = { field: spec.field, operator: spec.operators[0] };
  if (spec.valueKind === 'consent') {
    rule.channel = ContactChannel.SMS;
    rule.value = ConsentStatus.GRANTED;
  }
  return rule;
}

/**
 * Whether a rule is complete enough to submit, given its own field's spec.
 * Mirrors `parseRule` in `segment-definition.ts` just closely enough to keep a
 * user from submitting a document the server will 400 for a reason the form
 * could have said out loud first — the server is still the one that decides.
 */
export function ruleIsValid(rule: SegmentRule, spec: SegmentVocabularyField): boolean {
  switch (spec.valueKind) {
    case 'presence':
      return true;
    case 'number':
      return rule.value !== undefined && rule.value !== '' && !Number.isNaN(Number(rule.value));
    case 'money':
      return typeof rule.value === 'string' && /^-?\d{1,10}(\.\d{1,4})?$/.test(rule.value);
    case 'consent':
      return Boolean(rule.channel) && typeof rule.value === 'string' && rule.value.length > 0;
    case 'idList':
    case 'enumList':
    case 'monthList':
      return Array.isArray(rule.values) && rule.values.length > 0;
    default:
      return false;
  }
}

/** Month names for the `BIRTHDAY_MONTH` picker, 1-indexed to match the API's own numbering. */
export function monthLabel(month: number, locale: string): string {
  return new Date(Date.UTC(2000, month - 1, 1)).toLocaleString(locale, {
    month: 'long',
    timeZone: 'UTC',
  });
}
